import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

import { Pagination, Autoplay } from 'swiper/modules';
import { ApiService } from "../../../Components/Services/apiServices";
import Skeleton from "react-loading-skeleton";


const Testimonials = () => {

    const [testinomial, setTestinomial] = useState("");
    const [loading, setLoading] = useState(false);
{/* <i className="fa fa-hotel fa-2x text-primary" /> */}

    useEffect(() => {

        const fetchtestinomial = async () => {
            try {
                setLoading(true);
                const testinomialData = await ApiService.Commanfetchrequest('testimonials');
                setTestinomial(testinomialData);
                // console.log('testinomial data:', testinomialData);
            } catch (error) {
                console.log('error while fetching:', error);
            } finally {
                setLoading(false);
            }
        }


        fetchtestinomial();
    }, []);

    return (
        <>
            {loading ? (
                <>
                    <div id="testimonials" className="container-xxl testimonials my-5 py-5 bg-dark"
                        style={{
                            
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                        }}>
                        <div className="container">
                            <Swiper
                                loop={true}
                                speed={600}
                                navigation
                                autoplay={{ delay: 5000 }}
                                slidesPerView="auto"
                                pagination={{ clickable: true }}
                                modules={[Pagination, Autoplay]}
                                breakpoints={{
                                    320: {
                                        slidesPerView: 1,
                                        spaceBetween: 40,
                                    },
                                    1200: {
                                        slidesPerView: 3,
                                        spaceBetween: 1,
                                    },
                                }}
                            >
                                {[...Array(3)].map((_, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="testimonial-item">
                                            <div className="profile mt-auto">
                                                <Skeleton width={50} height={50} />
                                                <h3><Skeleton width={100} height={20} /></h3>
                                                <h4><Skeleton width={80} height={20} /></h4>
                                            </div>
                                            <p className="mt-2">
                                                <Skeleton width={270} height={200} />
                                            </p>
                                        </div>
                                    </SwiperSlide>
                                ))}


                            </Swiper>
                        </div>
                    </div>
                </>
            ) : (
                <div id="testimonials" className="container-xxl testimonials my-5 py-5 bg-dark"
                    style={{
                        backgroundImage: "url('/img/carousel-2.jpg')",
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}>
                    <div className="container">
                        <Swiper
                            loop={true}
                            speed={600}
                            navigation
                            autoplay={{ delay: 5000 }}
                            slidesPerView="auto"
                            pagination={{ clickable: true }}
                            modules={[Pagination, Autoplay]}
                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 40,
                                },
                                1200: {
                                    slidesPerView: 3,
                                    spaceBetween: 1,
                                },
                            }}
                        >
                            {testinomial.length > 0 ? (
                                testinomial.map((testimonial, index) => (
                                    <SwiperSlide key={index}>
                                        <div className="testimonial-item">
                                            <div className="profile mt-auto">
                                                <img
                                                    src={`https://hoteljpradmin.loopring.in/front/images/testonomials/${testimonial.customer_image}`}
                                                    className="testimonial-img"
                                                    alt={testimonial.customer_name}
                                                />
                                                <h3>{testimonial.customer_name}</h3>
                                                <h4>{testimonial.customer_detail}</h4>
                                            </div>
                                            <p className="mt-2">{testimonial.description}</p>
                                        </div>
                                    </SwiperSlide>
                                ))
                            ) : (
                               ""
                            )}


                        </Swiper>
                    </div>
                </div>
            )}



        </>
    )
}

export default Testimonials
